import { useParams } from 'react-router-dom'
import EditFinalQuestionSetForm from './EditFinalQuestionSetForm'

import { useGetFinalQuestionByIdQuery } from './questionSetsApiSlice'

import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
const EditFinalQuestionSet = () => {
    useTitle('geshtop-Exercise: Edit FinalQuestionSet')

    const { finalQuestionSetId } = useParams()


    const {
        data: finalQuestionSet,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetFinalQuestionByIdQuery({ finalQuestionSetId }, {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })




    if (!finalQuestionSet ) return <PulseLoader color={"#FFF"} />



    const content =
    <>
    <EditFinalQuestionSetForm finalQuestionSet={finalQuestionSet} />  
       
    </>

    return content
}
export default EditFinalQuestionSet